import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './global.scss';
import './fonts/font-face.scss';
import './sass/variables.scss';
import './sass/breakpoints.scss';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { eventGTMStart } from './utils/pushDataLayer.js';

eventGTMStart();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
